import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { BehaviorSubject, of, merge } from 'rxjs';
import { MenuItem } from '../../definition/menu-item.model';
import { TranslateService } from '@ngx-translate/core';
import { map, distinctUntilChanged, shareReplay, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { IdentityStore } from 'mm-web-core/identity/identity-store';
import { MenuServiceService } from './menu-service.service';

@Component({
  selector: 'mm-sider-menu',
  templateUrl: './sider-menu.component.html',
  styleUrls: ['./sider-menu.component.scss']
})
export class MmSiderMenuComponent implements OnInit {
  systemMenu: MenuItem[] = [];
  localLang = localStorage.getItem('lang');
  //发送"添加页签"事件
  @Output() private addTab = new EventEmitter();
  constructor(
    private router: Router,
    private menuSubscribeService: MenuServiceService,
    private translateService: TranslateService,
    private httpClient: HttpClient, private identityStore: IdentityStore) {
  }
  ngOnInit(): void {
  }
  // 英文环境，菜单显示toolTip效果，中文环境无toolTip效果
  get localLan(){
    return localStorage.getItem('lang')=='zh'?null:'hover';
  }
  hasItems(item: MenuItem) {
    return item.items && item.items.length > 0;
  }

  navigate(paths: string[]) {
    this.router.navigate(paths);
  }

  checkExternalLinkSelected(url) {
    var res = decodeURIComponent(this.router.url) === '/external-link/index?url=' + url;
    return res;
  }

  urlencode(url) {
    return encodeURIComponent(url);
  }

  navigateByUrl(data: MenuItem) {
    this.addTab.emit({name: data.name,url: data.url})
    this.router.navigateByUrl(data.url);
  }

  openUrl(data: MenuItem) {
    if (data.url) {
      this.addTab.emit({name: data.name,url: data.url})
      this.router.navigate(['/external-link/index'], { queryParams: { url: data.url } })
    }
  }

  openRedirectUrl(url: string) {
    if (url) {
      window.open(url)
    }
  }

  /*
   * 导出
   */
  export = () => {
  };

  combinePaths(paths: string[], path: string) {
    return [...paths, path];
  }

  dynamicMenus: any = {};

  getDynamicMenus(url: string, e) {
    if (!this.dynamicMenus[url]) {
      this.dynamicMenus[url] = this.httpClient.get<MenuItem[]>("api/_menu/dynamic", { params: { url: encodeURIComponent(url) } }).pipe(shareReplay());
    }

    this.dynamicMenus[url].subscribe(res => {
      this.receiveMenuMessage(res, e);
    })
    return this.dynamicMenus[url];
  }

  hasPermission(item: MenuItem) {
    if (!item.permission) return true;
    if (!localStorage.getItem('permissions')) return false;
    const permissions = JSON.parse(localStorage.getItem('permissions')) as Array<string>;
    return permissions.includes(item.permission);
  }

  hasFolderPermission(item: MenuItem) {
    return item.items.filter(item => this.hasPermission(item)).length > 0;
  }

  @Input() set items(_: MenuItem[]) {
    this.systemMenu = _;
    this.receiveMenuMessage();
  }

  @Input() mmInlineCollapsed = false;

  menuName(_: MenuItem) {
    return _.name[this.translateService.currentLang];
  }

  receiveMenuMessage(items = null, e = null) {
    if (items) {
      var mainMenu = this.systemMenu.filter(v => v.url === e.url)[0];
      if (mainMenu) {
        mainMenu.items = items;
      }
    }
    this.menuSubscribeService.receiveMessage(this.systemMenu);
  }

}
